import React from "react";
import { Slider as UISlider } from "@material-ui/core";

type CommissionSliderProps = {
  min: number;
  max: number;
  onChange: (name: string, value: number) => void;
  value: number;
  commission: number | null;
  disabled?: boolean;
  name: string;
};

export const CommissionSlider = ({
  min,
  max,
  onChange,
  value,
  disabled = false,
  name,
  commission,
}: CommissionSliderProps): React.ReactElement => (
  <section className="text-[10px] leading-[1em] text-[#9E9E9E]">
    <section className="grid grid-flow-col justify-between gap-[10px]">
      <span>-${min.toLocaleString("en-US")} USD</span>
      <span>+${max.toLocaleString("en-US")} USD</span>
    </section>
    <UISlider
      valueLabelDisplay="off"
      aria-label="custom thumb label"
      defaultValue={value}
      className="my-0 py-[7px]"
      min={min}
      max={max}
      value={value}
      onChange={(e, val) => {
        typeof val === "number" ? onChange(name, val) : () => null;
      }}
      disabled={disabled}
    />
    <section className="grid grid-flow-col justify-start gap-[10px]">
      <span>Commission:</span>
      <span className="text-[#2196F3]">
        {commission ? `${commission.toLocaleString("en-US")} USD` : "- -"}
      </span>
    </section>
  </section>
);
